import i18n from '@/utils/i18n';
import React from 'react';
import { Chip, XStack } from '@usepepper/sprout-kit-ui';
import { ManagerRepTimeRange } from '@/experiences/sales-portal/domain/prospects/screens/prospects/types';
import {
  REP_TIME_RANGE_LABEL_KEYS,
  REP_TIME_RANGE_OPTIONS,
} from '@/experiences/sales-portal/domain/prospects/screens/prospects/constants';

interface ProspectsManagerRepsTimeRangeProps {
  onChange: (timeRange: ManagerRepTimeRange) => void;
  value: ManagerRepTimeRange;
}

export const ProspectsManagerRepsTimeRange: React.FC<
  ProspectsManagerRepsTimeRangeProps
> = ({ onChange, value }) => (
  <XStack gap="$4">
    {REP_TIME_RANGE_OPTIONS.map((timeRange) => (
      <Chip
        aria-label={i18n.t(REP_TIME_RANGE_LABEL_KEYS[timeRange])}
        circular
        key={timeRange}
        onPress={() => onChange(timeRange)}
        pressable
        selected={value === timeRange}
        size="$sm"
      >
        <Chip.Text>{i18n.t(REP_TIME_RANGE_LABEL_KEYS[timeRange])}</Chip.Text>
      </Chip>
    ))}
  </XStack>
);
